
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lng]/privacy",
      function () {
        return require("private-next-pages/[lng]/privacy.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[lng]/privacy"])
      });
    }
  